import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Footer from "./footer";
import Navbar from "./Navbar";
const Billpunchaboutus = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    const script = document.createElement("script");
    script.src = "./on_seo.js";
    script.type = "module";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
      <Navbar />
      <div className="row">
        <div className="col-md-1"></div>
        <div className="col">
          <h1 className="text-center mt-3">About Us</h1>
          <p className="text-center">
            <b>
              Welcome to BillPunch, a stress-free and easy way to manage your
              bills. We at BillPunch know how stressful it can be to manage
              several bills at once. Our goal is to make managing your finances
              easier by offering a one-stop shop for all of your billing
              requirements.
              <br />
              <a
                href="https://www.youtube.com/watch?v=F6rCfakC-DI"
                target="_blank"
              >
                https://www.youtube.com/watch?v=F6rCfakC-DI
              </a>
            </b>
          </p>
          <div className="row">
            <div className="col-md-6 col-12">
              <img
                className="w-100"
                alt="Billpunch"
                src={require("../../src/Images/images/Billpunch_aboutus.png")}
              />
            </div>
            <div className="col-md-6 col-12 mt-md-5 mt-2">
              <h4 style={{ color: "RGB(93,136,228)" }}>
                <b>Who We Are?</b>
              </h4>
              <p>
                The creative platform BillPunch was created to assist you in
                managing your money. We are committed to making office
                management simple, effective, and available to everyone. We were
                founded by a group of motivated people with broad backgrounds in
                financial technology and customer service.
              </p>
              <p>
                <span style={{ fontSize: "1.1rem" }}>
                  <b> Our goal</b>
                </span>{" "}
                is to revolutionise bill management by providing creative,
                approachable alternatives. Our goal is to become the premier
                office management software, assisting people and companies in
                managing their finances, saving time, and lowering stress.
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 col-12 mt-md-5 order-md-first order-last mt-2 ">
              <h4 style={{ color: "RGB(93,136,228)" }}>
                <b>Why Choose BillPunch? </b>
              </h4>
              <p>
                Billpunch takes care of everything, including processing
                payroll, keeping track of costs, managing assets, and monitoring
                staff attendance and leave. Our software guarantees compliance,
                lowers errors, and boosts output. Our staff constantly works to
                satisfy our clients' evolving demands, and we are dedicated to
                using technology to build better workplaces.
                <br />
                <a
                  href="https://www.youtube.com/watch?v=ug5SfbWIGR8"
                  target="_blank"
                >
                  https://www.youtube.com/watch?v=ug5SfbWIGR8
                </a>
              </p>
            </div>
            <div className="col-md-6 col-12">
              <img
                className="w-100"
                alt="Billpunch"
                src={require("../../src/Images/images/about1.png")}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 col-12">
              <img
                className="w-100"
                alt="Billpunch"
                src={require("../../src/Images/images/about3.png")}
              />
            </div>
            <div className="col-md-6 col-12 mt-md-5 mt-2">
              <h4 style={{ color: "RGB(93,136,228)" }}>
                <b>Join Us Today</b>
              </h4>
              <p>
                Take the first step towards hassle-free bill management with
                BillPunch. Join our growing community of satisfied users and
                experience the difference. Sign up today and see how BillPunch
                can simplify your life!
              </p>
            </div>
          </div>
        </div>
        <div className="col-md-1"></div>
      </div>

      <Footer />
    </>
  );
};

export default Billpunchaboutus;
